import { SliderValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SliderValue';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { useMapheimDebounced } from 'hooks/general/useMapheimDebounced';
import { useContext } from 'react';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
}

// The icon size is always 200px, these are multiplies of that
const ICON_SIZE_STEPS = [0.1, 0.15, 0.2, 0.25, 0.3];
const TEXT_SIZE_STEPS = [10, 12, 14, 16, 18];

export const IconMarkerStyleSizeSubsection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const { marker } = props;

    function updateIconSize(value: number) {
        ctxEdit.updateWorldMarkerData(marker.id, { imageSize: value });
        ctxEdit.setMarkerDefault({
            ...ctxEdit.markerDefault,
            pin: {
                ...ctxEdit.markerDefault.pin,
                imageSize: value
            }
        });
    }
    function updateTextSize(value: number) {
        ctxEdit.updateWorldMarkerData(marker.id, { textSize: value });
        ctxEdit.setMarkerDefault({
            ...ctxEdit.markerDefault,
            pin: {
                ...ctxEdit.markerDefault.pin,
                textSize: value
            }
        });
    }

    const updateIconSizeDebounced = useMapheimDebounced(updateIconSize, 100);
    const updateTextSizeDebounced = useMapheimDebounced(updateTextSize, 100);

    return (
        <S_IconMarkerStyleSizeSubsection className={props.className}>
            <SidebarSubsection
                title={Localization.SIZE}
                icon={{ iconName: 'ruler' }}
                disableBottomBorder={true}
            >
                <SidebarContent>
                    <SidebarSectionRow>
                        <SliderValue
                            label={Localization.ICON}
                            steps={ICON_SIZE_STEPS}
                            value={marker.elementData.imageSize}
                            onValueChange={updateIconSizeDebounced}
                        />
                    </SidebarSectionRow>
                    <SidebarSectionRow>
                        <SliderValue
                            label={Localization.TEXT}
                            steps={TEXT_SIZE_STEPS}
                            value={marker.elementData.textSize}
                            onValueChange={updateTextSizeDebounced}
                        />
                    </SidebarSectionRow>
                </SidebarContent>
            </SidebarSubsection>
        </S_IconMarkerStyleSizeSubsection>
    );
};

const S_IconMarkerStyleSizeSubsection = styled.div``;
